// Importa `supa-base` dinamicamente quando necessário para evitar carregar
// o cliente no servidor.
import { enviarAvisoImportante } from "@/lib/notificacoes.functions";
import { verificarInconsistencias } from "@/lib/avisos";
import { nomeExib } from "@/lib/pessoas";
import { obterClienteDados } from "@/lib/obter-dados";
import { obterUsuarioCliente } from "@/lib/cliente-dados-helper";
import { INFO_DEVICE } from "@/lib/info-device";

// Usa o helper centralizado para obter o cliente (cliente seguro tanto no
// cliente quanto no servidor via dadosServidor). Retorna `any` temporariamente
// para evitar erros de tipagem durante a migração.

/**
 * Registra uma alteração de cadastro no relatório de auditoria.
 * Nunca interrompe a operação principal: falhas são apenas ignoradas.
 * Quando `importante` é verdadeiro, também dispara aviso por e-mail para os
 * destinatários cadastrados em Parâmetros.
 */
export async function logar(
  acao: string,
  detalhe: string,
  importante = false,
  operacao = 0,
  sql?: string,
) {
  try {
    const banco = await obterClienteDados();
    if (typeof window === "undefined") {
      // Server-side: no user session context here — skip audit log.
    } else {
      const usuario = await obterUsuarioCliente();
      const uid = usuario?.id;
      if (!uid) return;
      const device = JSON.stringify(INFO_DEVICE());
      const email = String(usuario?.email ?? "").slice(0, 60) || null;
      await (banco as any).from("audit_logs").insert({
        user_id: uid,
        email,
        acao,
        detalhe,
        operacao: Number.isInteger(operacao) ? operacao : 0,
        sql: sql || null,
        device: device || null,
      });

      if (importante) {
        const { data: perfil } = await (banco as any)
          .from("profiles")
          .select("apelido, nome, email")
          .eq("id", uid)
          .maybeSingle();
        await enviarAvisoImportante({
          data: { acao, detalhe, autor: nomeExib(perfil, usuario?.email ?? "") },
        });
      }
    }
  } catch {
    /* auditoria nunca deve quebrar o fluxo do usuário */
  }

  // Toda inclusão, cópia, alteração ou exclusão dispara a verificação
  // de inconsistências (a rotina só roda para administradores).
  try {
    await verificarInconsistencias();
  } catch {
    /* verificação nunca deve quebrar o fluxo do usuário */
  }
}
